import * as React from 'react'
import { api } from '../src/api'
import { Layout } from '../src/components/layout'

export const wrapPageElement = ({ element, props }: any) => {
  // console.log('FROM SSR')
  // api.getState().setRouteState(props)
  return <Layout {...props}>{element}</Layout>
}
